/* ==========================================================================
   SILETH 2.0 - Gratis-Schmuckstueck im Warenkorb (ONDRO-Stil)
   Nur /cart/update.js, nie ein zweites /cart/add.js (sonst doppelter AddToCart im Pixel).
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var url = function (p) { return ROOT.replace(/\/$/, '') + p; };

  /* ------------------------------------------------------------------------
     1. Gratis-Schmuckstueck
     ------------------------------------------------------------------------ */
  var FP = {
    silver: [47757025280339, 47757069484371, 47757018562899, 47757056180563, 47757058343251],
    gold:   [47757025247571, 47757069451603, 47757018530131, 47757056147795, 47757058310483],
    goldWatches: ['varenna-tobacco-heritage', 'varenna-two-tone']
  };
  var FREE_IDS = FP.silver.concat(FP.gold);
  var KEY_STATE = 'sileth_fp_state';
  var KEY_DECLINED = 'sileth_fp_declined';
  var KEY_AUTO = 'sileth_fp_auto';
  var busy = false;
  var queued = false;
  var selfChange = false;

  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { if (v === null) { sessionStorage.removeItem(k); } else { sessionStorage.setItem(k, v); } } catch (e) {} }

  function isWatch(item) {
    var t = (item.product_type || '').toLowerCase();
    return t.indexOf('uhren') !== -1 || (item.handle || '').indexOf('varenna') === 0;
  }

  function getCart() {
    return fetch(url('/cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function update(updates) {
    selfChange = true;
    return fetch(url('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      // Prestige laedt Drawer, Zaehler usw. neu
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      // zweiter Refresh: falls Prestige gerade noch eine eigene, aeltere Antwort rendert
      setTimeout(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }, 700);
      setTimeout(function () { selfChange = false; }, 1000);
      return cart;
    }).catch(function () { selfChange = false; });
  }

  // freeQty = jedes Schmuckstueck im Warenkorb. Die Rabattaktion macht EIN beliebiges
  // Schmuckstueck gratis - liegt schon eins drin (z. B. ein Ring), wird kein zweites nachgelegt.
  function analyse(cart) {
    var wq = 0, gold = false, free = [], jq = 0;
    (cart.items || []).forEach(function (it) {
      if (isWatch(it)) {
        wq += it.quantity;
        if (FP.goldWatches.indexOf(it.handle) !== -1) gold = true;
        return;
      }
      if (FREE_IDS.indexOf(it.variant_id) !== -1) free.push(it);
      if (FREE_IDS.indexOf(it.variant_id) !== -1 || (it.product_type || '').toLowerCase().indexOf('schmuck') !== -1) jq += it.quantity;
    });
    return { wq: wq, gold: gold, free: free, freeQty: jq };
  }

  function preferredId(state) {
    var list = state.gold ? FP.gold : FP.silver;
    return list[0];
  }

  function sync() {
    if (busy) { queued = true; return Promise.resolve(); }
    busy = true;
    return getCart().then(function (cart) {
      var s = analyse(cart);
      var prev = {};
      try { prev = JSON.parse(ssGet(KEY_STATE) || '{}'); } catch (e) {}

      // Kunde hat das Gratis-Stueck selbst entfernt, Uhr ist noch drin -> respektieren
      if (!selfChange && prev.freeQty > 0 && s.freeQty === 0 && s.wq > 0 && prev.wq > 0) {
        ssSet(KEY_DECLINED, '1');
      }
      if (s.wq === 0) ssSet(KEY_DECLINED, null);

      var declined = ssGet(KEY_DECLINED) === '1';
      var job = null;

      if (s.wq > 0 && s.freeQty === 0 && !declined) {
        var id = preferredId(s);
        ssSet(KEY_AUTO, String(id));
        var u = {}; u[id] = 1;
        markModules('busy');
        job = update(u);
      } else if (s.wq === 0 && s.freeQty > 0) {
        var auto = parseInt(ssGet(KEY_AUTO) || '0', 10);
        var line = s.free.filter(function (it) { return it.variant_id === auto; })[0];
        if (line) {
          var u2 = {}; u2[auto] = Math.max(0, line.quantity - 1);
          ssSet(KEY_AUTO, null);
          job = update(u2);
        }
      }

      ssSet(KEY_STATE, JSON.stringify({ wq: s.wq, freeQty: s.freeQty }));
      return (job || Promise.resolve()).then(function (c2) {
        if (c2 && c2.items) {
          var s2 = analyse(c2);
          ssSet(KEY_STATE, JSON.stringify({ wq: s2.wq, freeQty: s2.freeQty }));
        }
        paintModules(declined && s.freeQty === 0 ? 'declined' : null);
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (queued) { queued = false; sync(); }
    });
  }

  function markModules(state) {
    document.querySelectorAll('[data-s-fp]').forEach(function (m) { m.setAttribute('data-state', state); });
  }

  function paintModules(forceState) {
    document.querySelectorAll('[data-s-fp]').forEach(function (m) {
      if (forceState) m.setAttribute('data-state', forceState);
      else if (m.getAttribute('data-state') === 'pending' && ssGet(KEY_DECLINED) === '1') m.setAttribute('data-state', 'declined');
      paintMetal(m, m.getAttribute('data-metal') || 'silver');
      m.dataset.painted = '1';
    });
  }

  function paintMetal(m, metal) {
    m.setAttribute('data-metal', metal);
    m.querySelectorAll('[data-s-fp-metal]').forEach(function (b) {
      var on = b.getAttribute('data-s-fp-metal') === metal;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    m.querySelectorAll('[data-s-fp-opt]').forEach(function (o) {
      var img = o.querySelector('img');
      var src = o.getAttribute('data-' + metal + '-img');
      if (img && src && img.getAttribute('src') !== src) { img.removeAttribute('srcset'); img.src = src; }
      o.classList.toggle('is-unavailable', o.getAttribute('data-' + metal + '-ok') === 'false');
    });
  }

  function currentFreeLine(cart) {
    return (cart.items || []).filter(function (it) { return FREE_IDS.indexOf(it.variant_id) !== -1; })[0];
  }

  function swapTo(newId, module) {
    if (busy) return;
    busy = true;
    if (module) module.setAttribute('data-state', 'busy');
    getCart().then(function (cart) {
      var cur = currentFreeLine(cart);
      if (cur && cur.variant_id === newId) return null;
      var u = {};
      if (cur) u[cur.variant_id] = Math.max(0, cur.quantity - 1);
      u[newId] = ((cart.items || []).filter(function (it) { return it.variant_id === newId; })[0] || { quantity: 0 }).quantity + 1;
      ssSet(KEY_AUTO, String(newId));
      ssSet(KEY_DECLINED, null);
      return update(u);
    }).catch(function () {}).then(function () {
      busy = false;
      if (module && module.isConnected) module.setAttribute('data-state', 'added');
    });
  }

  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-s-fp-opt]');
    if (opt) {
      var m = opt.closest('[data-s-fp]');
      var metal = (m && m.getAttribute('data-metal')) || 'silver';
      var id = parseInt(opt.getAttribute('data-' + metal + '-id'), 10);
      if (id) swapTo(id, m);
      return;
    }
    var mb = e.target.closest('[data-s-fp-metal]');
    if (mb) {
      var mod = mb.closest('[data-s-fp]');
      var newMetal = mb.getAttribute('data-s-fp-metal');
      if (!mod || mod.getAttribute('data-metal') === newMetal) return;
      paintMetal(mod, newMetal);
      // aktuelles Stueck in der anderen Farbe uebernehmen (wenn eins gewaehlt ist)
      var active = mod.querySelector('[data-s-fp-opt].is-active') || mod.querySelector('[data-s-fp-opt]');
      if (active && mod.getAttribute('data-state') !== 'declined') {
        var nid = parseInt(active.getAttribute('data-' + newMetal + '-id'), 10);
        if (nid && active.getAttribute('data-' + newMetal + '-ok') !== 'false') swapTo(nid, mod);
      }
      return;
    }
    var rm = e.target.closest('[data-s-fp-remove]');
    if (rm) {
      // Kunde will das Gratis-Stueck nicht: fuer die Sitzung merken, nicht wieder nachlegen
      var rid = parseInt(rm.getAttribute('data-id'), 10);
      var m3 = rm.closest('[data-s-fp]');
      if (!rid || busy) return;
      ssSet(KEY_DECLINED, '1');
      ssSet(KEY_AUTO, null);
      if (m3) m3.setAttribute('data-state', 'declined');
      var ur = {}; ur[rid] = 0;
      update(ur);
      return;
    }
    var add = e.target.closest('[data-s-fp-add]');
    if (add) {
      var m2 = add.closest('[data-s-fp]');
      ssSet(KEY_DECLINED, null);
      var metal2 = (m2 && m2.getAttribute('data-metal')) || 'silver';
      var first = FP[metal2] ? FP[metal2][0] : FP.silver[0];
      swapTo(first, m2);
    }
  });

  // Prestige meldet jede Warenkorb-Aenderung (Hinzufuegen, Menge, Entfernen)
  var syncTimer = null;
  function scheduleSync() { clearTimeout(syncTimer); syncTimer = setTimeout(sync, 120); }
  document.addEventListener('cart:change', scheduleSync);
  document.addEventListener('cart:refresh', function () { if (!selfChange) scheduleSync(); });

  // Neu gerenderter Drawer (Prestige ersetzt ihn per Section Rendering) sofort korrekt darstellen
  var moQueued = false;
  var mo = new MutationObserver(function () {
    if (moQueued) return;
    moQueued = true;
    requestAnimationFrame(function () {
      moQueued = false;
      if (document.querySelector('[data-s-fp]:not([data-painted])')) paintModules(null);
    });
  });

  function boot() {
    paintModules(null);
    mo.observe(document.body, { childList: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();